import { getUserLimits } from "@/api/login";
import router, {
  routes,
  resetRouter,
  userRoutes,
  riskRoutes,
  channelRoutes,
  labelRoutes,
  levelRoutes,
  oddsDropTemplateRoutes,
  rankingRoutes,
  ipRoutes,
  riskyMatchMonitor,
  logRoutes,
  downOlderRoutes,
  eventRoutes,
  orderRoutes,
  warningRoutes,
  orderRiskTagRoutes
} from "@/router";
import {
  userListRoutes,
  userDetailRoutes,
  userModifyRoutes,
  riskListRoutes,
  channelListRoutes,
  tournamentConfigRoutes,
  //channelHistoryRoutes,
  riskAddRoutes,
  riskModifyRoutes,
  riskHistoryRoutes,
  riskDetailRoutes,
  labelListRoutes,
  levelListRoutes,
  oddsDropRoutes,
  orderListRoutes,
  ipListRoutes,
  monitorListRoutes,
  eventListRoutes,
  logListRoutes,
  downOlderListRoutes,
  rankingListRoutes,
  warningListRoutes,
  orderRiskTagListRoutes
} from "@/router/modules";
import { get } from "@/utils/request";

export default {
  state: {
    userName: "",
    limits: [],
    routes: [],
    addRoutes: []
  },
  mutations: {
    SET_NEW_ROUTES: (state, data) => {
      state.addRoutes = data;
      state.routes = routes.concat(data);
    },
    SET_LIMIT_LIST: (state, data) => {
      state.limits = data;
    }
  },
  actions: {
    getPrivilegeList({ commit }) {
      return new Promise(async resolve => {
        const { data } = await getUserLimits({ systemId: 7 });
        if (!data) {
          resolve([]);
          return;
        }
        const resList = data.roleFunction[0].functionInfoList;
        const privilegeRoutes = getPrivilegeRoutes(resList);

        commit("SET_LIMIT_LIST", resList);
        commit("SET_NEW_ROUTES", privilegeRoutes);

        resetRouter()
        const oldRoutes = [...routes]
        oldRoutes.push({
          path: '*',
          component: () => import('@/views/errorPage/404')
        })
        router.addRoutes(oldRoutes.concat(privilegeRoutes))
        resolve([...routes].concat(privilegeRoutes))
      });
    }
  }
};

function getPrivilegeRoutes(list = []) {
  const newRoutes = [];
  const userChildren = getUser(list);
  const orderChildren = getOrder(list);
  const rankingChildren = getRanking(list);
  const warnigChildren = getWarnig(list);
  const ipChildren = getIP(list);
  const monitorChildren = getMonitor(list);
  const eventChildren = getEvent(list);
  const riskChildren = getRisk(list);
  const channelChildren = getChannel(list);
  const labelChildren = getLabel(list);
  const levelChildren = getLevel(list);
  const oddsDropTemplateChildren = getOddsDrop(list);
  const logChildren = getLog(list);
  const downOlderChildren = getDownOlder(list);
  const orderRiskTagChildren = getOrderRiskTag(list);
  if (userChildren.length > 0) {
    userRoutes.children = userChildren;
    userRoutes.redirect = `/member/${userChildren[0].path}`;

    newRoutes.push(userRoutes);
  }
  //注释订单列表
  // if (orderChildren.length > 0) {
  //   orderRoutes.children = orderChildren;
  //   orderRoutes.redirect = `/systemOrder/${orderChildren[0].path}`;

  //   newRoutes.push(orderRoutes);
  // }
  if (channelChildren.length > 0) {
    channelRoutes.children = channelChildren;
    channelRoutes.redirect = `/channel/${channelChildren[0].path}`;

    newRoutes.push(channelRoutes);
  }
  if (rankingChildren.length > 0) {
    rankingRoutes.children = rankingChildren;
    rankingRoutes.redirect = `/ranking/${rankingChildren[0].path}`;

    newRoutes.push(rankingRoutes);
  }
  if (ipChildren.length > 0) {
    ipRoutes.children = ipChildren;
    ipRoutes.redirect = `/ip/${ipChildren[0].path}`;

    newRoutes.push(ipRoutes);
  }
  if (monitorChildren.length > 0) {
    riskyMatchMonitor.children = monitorChildren;
    riskyMatchMonitor.redirect = `/monitor/${monitorChildren[0].path}`;

    newRoutes.push(riskyMatchMonitor);
  }
  if (warnigChildren.length > 0) {
    warningRoutes.children = warnigChildren;
    warningRoutes.redirect = `/warnigHistory/${warnigChildren[0].path}`
    newRoutes.push(warningRoutes);
  }
  if (eventChildren.length > 0) {
    eventRoutes.children = eventChildren;
    eventRoutes.redirect = `/event/${eventChildren[0].path}`;

    newRoutes.push(eventRoutes);
  }
  if (riskChildren.length > 0) {
    riskRoutes.children = riskChildren;
    riskRoutes.redirect = `/risk/${riskChildren[0].path}`;

    newRoutes.push(riskRoutes);
  }

  if (labelChildren.length > 0) {
    labelRoutes.children = labelChildren;
    labelRoutes.redirect = `/label/${labelChildren[0].path}`;

    newRoutes.push(labelRoutes);
  }

  if (levelChildren.length > 0) {
    levelRoutes.children = levelChildren;
    levelRoutes.redirect = `/level/${levelChildren[0].path}`;

    newRoutes.push(levelRoutes);
  }

  if (oddsDropTemplateChildren.length > 0) {
    oddsDropTemplateRoutes.children = oddsDropTemplateChildren;
    oddsDropTemplateRoutes.redirect = `/oddsDropTemplate/${oddsDropTemplateChildren[0].path}`;

    newRoutes.push(oddsDropTemplateRoutes);
  }
  if(orderRiskTagChildren.length > 0){
    orderRiskTagRoutes.children = orderRiskTagChildren;
    orderRiskTagRoutes.redirect = `/orderRiskTag/${orderRiskTagChildren[0].path}`
    newRoutes.push(orderRiskTagRoutes);
  }
  if (logChildren.length > 0) {
    logRoutes.children = logChildren;
    logRoutes.redirect = `/systemlog/${logChildren[0].path}`;

    newRoutes.push(logRoutes);
  }
  
  if (downOlderChildren.length > 0) {
    downOlderRoutes.children = downOlderChildren;
    downOlderRoutes.redirect = `/downOlder/${downOlderChildren[0].path}`;

    newRoutes.push(downOlderRoutes);
  }

  return newRoutes;
}


function getUser(list) {
  const arr = [];
  const hasUserList = hasPrivilege(list, "UMUL");
  const hasUserDetail = hasPrivilege(list, "UMUD");
  const hasUserModify = hasPrivilege(list, "UMUM");

  if (hasUserList && hasUserList.featureStatus !== 3) {
    arr.push(userListRoutes);
  }
  if (hasUserDetail && hasUserDetail.featureStatus !== 3) {
    arr.push(userDetailRoutes);
  }
  if (hasUserModify && hasUserModify.featureStatus !== 3) {
    arr.push(userModifyRoutes);
  }

  return arr;
}

function getRisk(list) {
  // featureStatus: 1是激活 2是暂停 3是冻结
  const arr = [];
  const hasRiskList = hasPrivilege(list, "RLRL");
  const hasRiskDetail = hasPrivilege(list, "RLRD");
  const hasRiskAdd = hasPrivilege(list, "RLRA");
  const hasRiskModify = hasPrivilege(list, "RLRM");
  const hasRiskHistory = hasPrivilege(list, "RLRH");

  if (hasRiskList && hasRiskList.featureStatus !== 3) {
    arr.push(riskListRoutes);
  }
  if (hasRiskDetail && hasRiskDetail.featureStatus !== 3) {
    arr.push(riskDetailRoutes);
  }
  if (hasRiskAdd && hasRiskAdd.featureStatus !== 3) {
    arr.push(riskAddRoutes);
  }
  if (hasRiskModify && hasRiskModify.featureStatus !== 3) {
    arr.push(riskModifyRoutes);
  }
  if (hasRiskHistory && hasRiskHistory.featureStatus !== 3) {
    arr.push(riskHistoryRoutes);
  }

  return arr;
}

function getChannel(list) {
  // featureStatus: 1是激活 2是暂停 3是冻结
  const arr = [];
  const hasChannelList = hasPrivilege(list, "CHANNELLEVEL");
  if (hasChannelList && hasChannelList.featureStatus !== 3) {
    arr.push(channelListRoutes);
    arr.push(tournamentConfigRoutes);
    //arr.push(channelHistoryRoutes);
  }
  return arr;
}

function getLabel(list) {
  const arr = [];
  const hasLabelList = hasPrivilege(list, "LMLL");

  // if (hasLabelList && hasLabelList.featureStatus !== 3) {
  //   arr.push(labelListRoutes);
  // }

  return arr;
}

function getOddsDrop(list) {
  const arr = [];
  const hasOddsDrop = hasPrivilege(list, "OddsDrop");

  if (hasOddsDrop && hasOddsDrop.featureStatus !== 3) {
    arr.push(oddsDropRoutes);
  }

  return arr;
}

function getLevel(list) {
  const arr = [];
  const hasLevelList = hasPrivilege(list, "LEVEL_LIST");

  if (hasLevelList && hasLevelList.featureStatus !== 3) {
    arr.push(levelListRoutes);
  }

  return arr;
}

function getRanking(list) {
  const arr = [];
  const hasRankingList = hasPrivilege(list, "PRRL");

  if (hasRankingList && hasRankingList.featureStatus !== 3) {
    arr.push(rankingListRoutes);
  }

  return arr;
}

function getWarnig(list) {
  const arr = [];
  const hasWarningList = hasPrivilege(list, "WarningHistory");

  if (hasWarningList && hasWarningList.featureStatus !== 3) {
    arr.push(warningListRoutes);
  }

  return arr;
}

function getOrderRiskTag(list) {
  const arr = [];
  const hasOrderRiskTag = hasPrivilege(list, "OrderRiskTag");

  if (hasOrderRiskTag && hasOrderRiskTag.featureStatus !== 3) {
    arr.push(orderRiskTagListRoutes);
  }

  return arr;
}

function getLog(list) {
  const arr = [];
  const hasLogList = hasPrivilege(list, "SLLL");

  if (hasLogList && hasLogList.featureStatus !== 3) {
    arr.push(logListRoutes);
  }

  return arr;
}

function getDownOlder(list) {
  const arr = [];
  const hasDownOlder = hasPrivilege(list, "DOWN_ORDER");

  if (hasDownOlder && hasDownOlder.featureStatus !== 3) {
    //arr.push(downOlderListRoutes);
  }

  return arr;
}

function getIP(list) {
  const arr = [];
  const hasIPList = hasPrivilege(list, "URISK/IP");
  if (hasIPList && hasIPList.featureStatus !== 3) {
    arr.push(ipListRoutes);
  }

  return arr;
}

function getMonitor(list) {
  const arr = [];
  const hasMonitorList = hasPrivilege(list, "URISK/Match");
  if (hasMonitorList && hasMonitorList.featureStatus !== 3) {
    arr.push(monitorListRoutes);
  }
  return arr;
}

function getEvent(list) {
  const arr = [];
  const hasEventList = hasPrivilege(list, "EMEL");

  if (hasEventList && hasEventList.featureStatus !== 3) {
    arr.push(eventListRoutes);
  }

  return arr;
}

function getOrder(list) {
  const arr = [];
  const hasOrderList = hasPrivilege(list, "SOOL");

  if (hasOrderList && hasOrderList.featureStatus !== 3) {
    arr.push(orderListRoutes);
  }

  return arr;
}

function hasPrivilege(list, str) {
  return list && list.find(l => l.privilegeMark === str);
}
